// These are fallback values for the case
// when API requests fail.

export const followedContentErrorViewModel = {
  title: "My Followed Content",
  error: {
    name: "We're sorry! This page is temporarily unavailable.",
    message:
      "We are working on resolving the problem. Please try again shortly.",
  },
};
